export async function forceTokenRefresh(firebaseUser) {
	return firebaseUser.getIdToken(true)
}